import { jsx as r, jsxs as d } from "react/jsx-runtime";
const t = (a) => {
  const { icon: e, label: s, center: n = !0, className: c = "" } = a;
  return /* @__PURE__ */ r("li", { className: `dropdown-header ${n ? "center" : ""} ${c}`, children: /* @__PURE__ */ d("span", { className: "dropdown-header-text", children: [
    e && /* @__PURE__ */ r("span", { className: "margin-right-5", children: e }),
    s
  ] }) });
};
export {
  t as default
};
//# sourceMappingURL=DropdownHeader.js.map
